export class FormGradimentoDTO {

    constructor(formData) {
	    this.idUtente = parseInt(formData.idUtente) || null;
	    this.idSottoProgetto = parseInt(formData.idSottoProgetto) || null;
	    this.idForm = parseInt(formData.idForm) || null;

        // Mappatura valutazioni numeriche
        this.valutazioneCoinvolgimento = parseInt(formData.coinvolgimento) || null;
        this.valutazioneNuoveAbilita = parseInt(formData.nuoveAbilita) || null;
        this.valutazioneCaricoLavoro = parseInt(formData.caricoLavoro) || null;
        this.valutazioneIstruzioni = parseInt(formData.istruzioniChiare) || null;
        this.valutazioneOrariLavoro = parseInt(formData.orariLavoro) || null;
        this.valutazioneAbitazione = parseInt(formData.sistemazione) || null;
        this.valutazionePosizioneAlloggio = parseInt(formData.posizioneSistemazione) || null;
        this.valutazioneTrasportiLocali = parseInt(formData.trasportiLocali) || null;
        this.valutazioneSupporto = parseInt(formData.supportoOrganizzazione) || null;

        // Mappatura commenti testuali
        this.commentiPositivi = formData.commentiPositivi || null;
        this.commentiNegativi = formData.commentiNegativi || null;
        this.altriCommenti = formData.altriCommenti || null;
    }

    /**
     * Metodo per validare i dati prima dell'invio
     * @returns {boolean} True se i dati sono validi, altrimenti False
     
    isValid() {
        // Verifica che i campi obbligatori siano presenti
        return this.participantName &&
            this.participantName.trim() !== '' &&
            this.startDate &&
            this.endDate;
    }*/

    /**
     * Conta quante domande di valutazione sono state compilate
     * @returns {number} Il numero di domande compilate
     
    getCompletionRate() {
        const ratingFields = Object.values(this.ratings).filter(value => value !== '').length;
        const totalRatingFields = 9; // Numero totale di domande a scelta multipla

        return Math.round((ratingFields / totalRatingFields) * 100);
    }*/

    /**
     * Verifica se il form è completo (tutte le domande compilate)
     * @returns {boolean} True se tutte le domande sono state compilate
     
    isComplete() {
        return this.getCompletionRate() === 100 &&
            this.appreciateHost.trim() !== '' &&
            this.dislikeHost.trim() !== '';
    }*/

    /*toJSON() {
        return {
            valutazioneCoinvolgimento: this.valutazioneCoinvolgimento,
            valutazioneNuoveAbilita: this.valutazioneNuoveAbilita,
            valutazioneCaricoLavoro: this.valutazioneCaricoLavoro,
            valutazioneIstruzioni: this.valutazioneIstruzioni,
            valutazioneOrariLavoro: this.valutazioneOrariLavoro,
            valutazioneAbitazione: this.valutazioneAbitazione,
            valutazionePosizioneAlloggio: this.valutazionePosizioneAlloggio,
            valutazioneTrasportiLocali: this.valutazioneTrasportiLocali,
            valutazioneSupporto: this.valutazioneSupporto,
            commentiPositivi: this.commentiPositivi,
            commentiNegativi: this.commentiNegativi,
            altriCommenti: this.altriCommenti
        };
    }*/
}